import { useTranslation } from 'react-i18next';

const useIntlMessage = () => {
  const { t } = useTranslation();

  return (id, values) => {
    const translate = t(id, values);
    return translate;
  };
};

export default useIntlMessage;
